<div class="ui-form-field" [attr.data-appearance]="appearance()">
  @if (label()) {
    <label class="ui-form-field__label" [attr.for]="id() || null">
      {{ label() | uiLabelTranslate }}
      @if (required()) {
        <span class="ui-form-field__required">*</span>
      }
    </label>
  }

  <div class="ui-form-field__control-wrap">
    @if (type() === 'textarea') {
      <textarea
        class="ui-form-field__control"
        [id]="id() || null"
        [value]="value()"
        [placeholder]="placeholder() | uiLabelTranslate"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [rows]="rows()"
        (input)="onValueChange(fieldValue.value)"
        #fieldValue
      ></textarea>
    } @else {
      <input
        class="ui-form-field__control"
        [id]="id() || null"
        [type]="type()"
        [value]="value()"
        [placeholder]="placeholder() | uiLabelTranslate"
        [disabled]="disabled()"
        [readOnly]="readonly()"
        [required]="required()"
        [min]="min() || null"
        [max]="max() || null"
        [step]="step() || null"
        (input)="onValueChange(fieldValue.value)"
        #fieldValue
      />
    }
    <span class="ui-form-field__suffix">
      <ng-content select="[uiFieldSuffix]" />
    </span>
  </div>

  @if (error()) {
    <p class="ui-form-field__error">{{ error() | uiLabelTranslate }}</p>
  } @else if (hint()) {
    <p class="ui-form-field__hint">{{ hint() | uiLabelTranslate }}</p>
  }
</div>
